<script lang="ts" setup>
import { useFetchBlockDetail, ViewBlockDetailInfo } from '~/api/service/block/[blockNumber]/index.service'
import BlocksPageDetail from '~/components/@pages/blocks/[blockNumber]/BlocksPageDetail.vue'
import BlocksPageCharater from '~/components/@pages/blocks/BlocksPageCharater.vue'
import Spinner from '~/components/loading/Spinner.vue'
import NoDataPreview from '~/components/preview/NoDataPreview.vue'
import CustomSuspense from '~/components/suspense/CustomSuspense.vue'
import { getBreadCrumb } from '~/utils/breadCrumbList'
import { getRouteParam } from '~/utils/route.util'

const blockNumber = getRouteParam('blockNumber')

useSeoMeta(getMeta(`Block ${blockNumber}`, `Explore details of Block ${blockNumber}`))

const { data, isLoading, isError } = useFetchBlockDetail(blockNumber)

useHead(getBreadCrumb())
</script>

<template>
  <Card class="mt-4">
    <CustomSuspense
      :is-loading="isLoading"
      :is-empty="isError"
    >
      <template #loading>
        <Spinner />
      </template>
      <template #empty>
        <NoDataPreview />
      </template>
      <template #default>
        <BlocksPageDetail :data="data as ViewBlockDetailInfo" />
      </template>
    </CustomSuspense>
  </Card>
</template>

<style scoped>

</style>